import React from 'react'
import {KTIcon} from '../../_metronic/helpers'
import SearchQueryData from './SearchQueryData'

type Props = {
  searchQuery: string
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSearchKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onSearchSubmit: () => void
  searchPlaceholder?: string
  isLoading?: boolean
  isFilterActive?: boolean
  onOpenFilter?: () => void
  showFilterButton?: boolean
  onExport?: () => void
  exporting?: boolean
  showExport?: boolean
}

/** Shared card header: search, filter, export. */
const ListPageHeader = ({
  searchQuery,
  onSearchChange,
  onSearchKeyDown,
  onSearchSubmit,
  searchPlaceholder = 'Search',
  isLoading,
  isFilterActive,
  onOpenFilter,
  showFilterButton = true,
  onExport,
  exporting,
  showExport = true,
}: Props) => (
  <div className='card-header border-0 pt-5 d-flex justify-content-between'>
    <div>
      <SearchQueryData
        value={searchQuery}
        handleChange={onSearchChange}
        handleKeyDown={onSearchKeyDown}
        fetchData={onSearchSubmit}
        placeholder={searchPlaceholder}
      />
    </div>
    <div>
      {showFilterButton && onOpenFilter && (
        <button
          disabled={isLoading}
          type='button'
          className={`btn me-3 ${isFilterActive ? 'btn-primary' : 'btn-light-primary'}`}
          onClick={onOpenFilter}
        >
          <KTIcon iconName='filter' className='fs-2' />
          Filter
        </button>
      )}
      {showExport && onExport && (
        <button
          type='button'
          className='btn btn-light-primary me-3'
          disabled={exporting}
          onClick={onExport}
        >
          {exporting ? (
            <span className='spinner-border spinner-border-sm align-middle me-2' role='status' />
          ) : (
            <KTIcon iconName='exit-up' className='fs-2' />
          )}
          {exporting ? 'Exporting…' : 'Export'}
        </button>
      )}
    </div>
  </div>
)

export default ListPageHeader
